import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../../components/DataTable';
const DoorModelsPage = () => {
    const [doorModelGroups, setDoorModelGroups] = useState([]);
    const [doorModels, setDoorModels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        loadData();
    }, []);
    const loadData = async () => {
        setLoading(true);
        setError('');
        try {
            const [groupsRes, modelsRes] = await Promise.all([
                fetch('/api/pricing/door_model_groups', { credentials: 'include' }),
                fetch('/api/pricing/door_models', { credentials: 'include' }),
            ]);
            if (groupsRes.status === 401 || modelsRes.status === 401) {
                window.location.href = '/login';
                return;
            }
            const [groupsData, modelsData] = await Promise.all([
                groupsRes.json(),
                modelsRes.json(),
            ]);
            setDoorModelGroups(groupsData.data || []);
            setDoorModels(modelsData.data || []);
        }
        catch (err) {
            console.error('Failed to load data:', err);
            setError(err.message || 'Failed to load data');
        }
        finally {
            setLoading(false);
        }
    };
    const handleAdd = async (data) => {
        try {
            const response = await fetch('/api/pricing/door_models', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    name: data.name,
                    model_group_id: data.model_group_id || null,
                    description: data.description || null,
                    sort_order: data.sort_order || 0,
                }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to add series');
            }
            await loadData();
        }
        catch (err) {
            throw new Error(err.message || 'Failed to add series');
        }
    };
    const handleUpdate = async (id, data) => {
        try {
            const response = await fetch(`/api/pricing/door_models/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    name: data.name,
                    model_group_id: data.model_group_id || null,
                    description: data.description || null,
                    sort_order: data.sort_order,
                }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to update series');
            }
            await loadData();
        }
        catch (err) {
            throw new Error(err.message || 'Failed to update series');
        }
    };
    const handleDelete = async (id) => {
        try {
            const response = await fetch(`/api/pricing/door_models/${id}`, {
                method: 'DELETE',
                credentials: 'include',
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to delete series');
            }
            await loadData();
        }
        catch (err) {
            throw new Error(err.message || 'Failed to delete series');
        }
    };
    const columns = [
        { key: 'name', label: 'Name', type: 'text', required: true },
        {
            key: 'model_group_id',
            label: 'Door Model',
            type: 'select',
            options: doorModelGroups.map((g) => ({ value: g.id, label: g.name })),
            render: (value, row) => row.model_group_name || '-',
        },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0, defaultValue: 0 },
    ];
    return (_jsx("div", { className: "min-h-screen bg-secondary-50", children: _jsxs("div", { className: "max-w-7xl mx-auto px-6 py-8", children: [_jsxs("div", { className: "flex items-center justify-between mb-8", children: [_jsxs("div", { className: "flex items-center gap-4", children: [_jsxs(Link, { to: "/", className: "flex items-center gap-2 text-secondary-600 hover:text-secondary-900 transition-colors", children: [_jsx("svg", { className: "w-5 h-5", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10 19l-7-7m0 0l7-7m-7 7h18" }) }), "Back to Dashboard"] }), _jsx("h1", { className: "text-3xl font-bold text-secondary-900", children: "Series" })] }), _jsx(Link, { to: "/logout", className: "px-4 py-2 text-primary-600 hover:text-primary-700 border border-primary-600 rounded-lg hover:bg-primary-50 transition-colors font-medium", children: "Logout" })] }), error && (_jsx("div", { className: "mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg", children: error })), _jsx("div", { className: "bg-white rounded-xl shadow-sm p-6", children: loading ? (_jsxs("div", { className: "text-center py-12", children: [_jsx("div", { className: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" }), _jsx("p", { className: "mt-2 text-secondary-600", children: "Loading..." })] })) : (_jsx(DataTable, { columns: columns, data: doorModels, onAdd: handleAdd, onUpdate: handleUpdate, onDelete: handleDelete })) })] }) }));
};
export default DoorModelsPage;
